var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Home")]),_c('Authentication'),_c('button',{on:{"click":function($event){return _vm.$store.dispatch('createNewScript')}}},[_vm._v("New")]),(_vm.$store.state.isAuthenticated)?_c('ScriptList'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }